import React from 'react'
import { BsDot } from 'react-icons/bs'
import { FaCopyright, FaRegCopyright } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styles from '../Components/ContentFooter.module.css'

const ContentFooter = () => {
    return (
        <div className={styles.mainWrapper}>
            <div>

            </div>
            <div className={styles.copyrightLine}>
                <FaRegCopyright />&nbsp;Stylelink In.
            </div>
            <div className={styles.rowLink}>
                <Link >
                    Privacy
                </Link>
                <BsDot color="#ffffff85" />
                <Link >
                    Terms
                </Link>
                <BsDot color="#ffffff85" />
                <Link>
                    About Stylelink
                </Link>
            </div>
        </div>
    )
}

export default ContentFooter